export default "__VITE_ASSET__Cr3$9$bS__";